import { commits, getters } from '@/modules/core/app/helpers/store';
import AuthService from '@/modules/auth/services/AuthService';
import { CurrentEstate } from '@/modules/estate/models/CurrentEstate';
import { BaseService } from '@/modules/core/app/services/abstracts/BaseService';

export class ViewingEstateDetailsService extends BaseService {
  private previousPermissionKeys: string[] | undefined = undefined;

  reset(): void {
    commits.auth.setIsViewingEstateDetails(null);
  }

  async initialize(estate: Partial<CurrentEstate>): Promise<void> {
    this.previousPermissionKeys = getters.auth.getUser()?.permission?.keys;
    commits.auth.setIsViewingEstateDetails(CurrentEstate.mapModel(estate));
    commits.auth.setPermissionKeys(await AuthService.getPermissionKeys());
  }

  unset(): void {
    commits.auth.unsetIsViewingEstateDetails();
    if (this.previousPermissionKeys !== undefined) {
      commits.auth.setPermissionKeys(this.previousPermissionKeys);
    }
  }
}

export default new ViewingEstateDetailsService();
